"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewedTracking = void 0;
var react_1 = require("react");
var useViewedTracking = function (props) {
    var containerRef = props.containerRef, onViewed = props.onViewed, hasLoaded = props.hasLoaded;
    var _a = (0, react_1.useState)(false), hasIntersected = _a[0], setHasIntersected = _a[1];
    var hasFiredRef = (0, react_1.useRef)(false);
    // Fire callback when conditions are met
    (0, react_1.useEffect)(function () {
        if (hasLoaded && hasIntersected && !hasFiredRef.current) {
            onViewed();
            hasFiredRef.current = true;
        }
    }, [hasLoaded, hasIntersected, onViewed]);
    // Intersection detection
    (0, react_1.useEffect)(function () {
        if (!containerRef.current) {
            return;
        }
        // IntersectionObserver is supported by our browserslist
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            if (entry.isIntersecting) {
                setHasIntersected(true);
            }
        });
        observer.observe(containerRef.current);
        return function () { return observer.disconnect(); };
    }, [containerRef, onViewed, hasLoaded]);
};
exports.useViewedTracking = useViewedTracking;
